import {MenuItem} from '@mui/material';
import {forwardRef, type HTMLProps, type ReactNode, type Ref} from 'react';

export type MenuItemAnchorProps = {
    href: HTMLProps<HTMLAnchorElement>['href'];
    children: ReactNode;
};

export const MenuItemAnchor = forwardRef(function MenuItemAnchor(
    props: MenuItemAnchorProps,
    ref: Ref<any>
) {
    return <MenuItem ref={ref} {...props} component='a' />;
});
